<template>
  <StepLayout
    :on-save="onSave"
    :is-busy-on-save="isBusyOnSave"
    :on-next="onNext"
    :is-busy-on-next="isBusyOnNext"
    :on-back="onBack"
    :is-disabled="isDisabled"
    helpscout-article="65686843b1d9b5438dbdb493"
    step-navigation-button-data-ec="bulk_send_signing_sequence_page"
  >
    <template v-slot:title>
      {{ $t('bulkSend.steps.signingSequence.title') }}
    </template>

    <SigningSequenceSelector
      id="bulk_sends"
      ec="bulkSends"
      :showTitle="false"
      :current-selection="sequence"
      @selectionUpdated="setSequence"
    >
      <template v-slot:parallelLabel="{ forId }">
        <SequenceLabel
          :label="$t('signingSequence.ui.labels.parallel')"
          :for="forId"
        >
          {{ $t('bulkSend.steps.signingSequence.descriptions.parallel') }}
        </SequenceLabel>
      </template>
      <template v-slot:sequentialLabel="{ forId }">
        <SequenceLabel
          :label="$t('signingSequence.ui.labels.sequential')"
          :for="forId"
        >
          {{ $t('bulkSend.steps.signingSequence.descriptions.sequential') }}
        </SequenceLabel>
      </template>
    </SigningSequenceSelector>
  </StepLayout>
</template>

<script>
import { computed, ref } from 'vue';
import { useGetters } from 'vuex-composition-helpers/dist';

import { useBulkSendStepsNavigation } from '@/composables/bulkSend/steps';

import StepLayout from '@/components/ui/bulkSend/StepLayout.vue';
import SequenceLabel from '@/components/ui/signingSequence/labels/SequenceLabel.vue';
import SigningSequenceSelector from '@/components/ui/signingSequence/SigningSequenceSelector.vue';

export default {
  name: 'SigningSequencePage',
  components: {
    StepLayout,
    SigningSequenceSelector,
    SequenceLabel,
  },
  setup() {
    const { bulkSend } = useGetters({ bulkSend: 'bulkSend/bulkSend' });

    // local state
    const sequence = ref(bulkSend.value.parallel_signing ? 'parallel' : 'sequential');
    function setSequence(newSequence) {
      sequence.value = newSequence;
    }

    const updateValue = computed(() => ({
      parallel_signing: sequence.value === 'parallel',
    }));

    const {
      onNext,
      isBusyOnNext,
      onSave,
      isBusyOnSave,
      onBack,
      isDisabled,
    } = useBulkSendStepsNavigation(
      'bulkSend/updateBulkSend',
      updateValue,
    );

    return {
      sequence,
      setSequence,
      onSave,
      isBusyOnSave,
      onNext,
      isBusyOnNext,
      onBack,
      isDisabled,
    };
  },
};
</script>
